'use client'

import { useState } from 'react'
import { AgentListContext } from './context'
export default function AgentSearchListContent({
  state,
  children
}) {

  const [totals, setTotals] = useState()
  const [suburbs, setSuburbs] = useState()

  return (
    <AgentListContext.Provider value={{ ...state, totals, setTotals, suburbs, setSuburbs }}>
      {children}
    </AgentListContext.Provider>
  )
}